import { Box, Button, TextField, Tooltip } from '@material-ui/core'
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart'
import LoopIcon from '@material-ui/icons/Loop'
import React, { useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { checkMonitorArticles } from '../../lib/helper/userHelper'
import { useLanguage } from '../../lib/hooks/languageHooks'
import { strings as Localization } from '../../lib/Localization'
import { addToCart } from '../../redux/cartSlice'
import { setSnackbarMessage } from '../../redux/userMessageSlice'
import useStyles from './styles'

const SpeedOrderNavbar = () => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const classes = useStyles()
    const lang = useLanguage()
    const ref = useRef()

    const defaultValues = {
        articleNumber: null,
        quantity: 1
    }

    const { register, handleSubmit, watch, reset } = useForm({ defaultValues: defaultValues })

    const parse = (i) => {
        return parseInt(i, 10)
    }

    const onSubmit = (data) => {
        checkMonitorArticles(lang, [data.articleNumber], (result) => {
            if (!result.includes(data.articleNumber) && data.quantity > 0) {
                const q = parse(data.quantity)
                dispatch(addToCart(data.articleNumber, q))
                dispatch(setSnackbarMessage(`${Localization.itemNumber} ${data.articleNumber} ${Localization.hasBeenAddedToCart}.`, 'success'))
            } else {
                if (data.quantity === 0) {
                    dispatch(setSnackbarMessage(Localization.articleCouldNotBeAddedQuantityZero, 'error'))
                } else {
                    dispatch(setSnackbarMessage(`${Localization.itemNumber} ${data.articleNumber} ${Localization.couldNotBePlacedInCart}.`, 'error'))
                }
            }
        }, setLoading)
        reset()

        ref.current?.focus()
    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} id={`quick-add-navbar`}>
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                    <TextField
                        InputProps={{
                            classes: { input: classes.input }
                        }}
                        classes={classes.textField}
                        style={{ width: 100, marginRight: 10 }}
                        variant='standard'
                        placeholder={Localization.itemNumber}
                        size='small'
                        inputRef={ref}
                        {...register('articleNumber', { required: true })}
                    />
                    <TextField
                        InputProps={{
                            classes: { input: classes.input }
                        }}
                        classes={classes.textField}
                        style={{ width: 55 }}
                        variant='standard'
                        placeholder={Localization.qty}
                        size='small'
                        {...register('quantity', { required: true })}
                    />
                    <Tooltip title={Localization.addToCart}>
                        <Button
                            size='small'
                            variant='text'
                            type='submit'
                            disabled={!watch('articleNumber') || !watch('quantity') || loading}
                            classes={{
                                root: classes.buttonRoot,
                                outlinedSizeSmall: classes.outlinedSmall
                            }}
                            style={{ marginLeft: 0, paddingLeft: 8, paddingRight: 8 }}
                        >
                            {!loading ? <AddShoppingCartIcon /> : <LoopIcon className={classes.working} />}
                        </Button>
                    </Tooltip>
                </Box>
            </form>
        </>
    )
}

export default SpeedOrderNavbar
